import { FETCHING_USER_DETAILS, SAVE_USER_DETAILS, USER_DETAILS_FETCH_FAILED } from './types';
import { HiverAxios, fetchApiAuthToken, isFeatureEnabled,AUTOMATIONS_AUTH_URL } from 'h-commons';
import storeProvider from '../../../storeProvider';
import { setConfigKey, getConfigKey } from '@hiver/hiver-config-library';

const USER_DETAILS_URL = '/main/getExtUserDetails';
/**
 * Action dispatched before making the request
 */
function fetchingUserDetails() {
  return {
    type: FETCHING_USER_DETAILS
  };
}

function setConfigKeys(userDetails){
  const store = storeProvider.getStore();
  const { appModes } = store.getState();
  
  let loggedInUserId = appModes.userSession;
  if (!loggedInUserId) {
    loggedInUserId = userDetails.userId;
  }
  setConfigKey('emailId', userDetails.emailId);
  setConfigKey('usersession', loggedInUserId);
}

const fetchAutomationAuthToken = (emailId, userId) => {
  const config_key = 'automations_auth_token';
  fetchApiAuthToken(emailId, userId, config_key, AUTOMATIONS_AUTH_URL );
}

/**
 * Dispatches action on successfull fetching of loggedin user details
 */
export function fetchUserDetails(callback) {
  return (dispatch) => {
    dispatch(fetchingUserDetails());
     HiverAxios({
      url: `${USER_DETAILS_URL}`,
      type: 'post',
      params: {},
      callback: (response) => {
        try{
          window.hiver = {};
          window.hiver.availableFeatures = response.data.availableFeatures;
          window.hiver.userid = response.data.userId;
          window.hiver.usergroupid = Number(response.data.usergroupId);
          setConfigKeys(response.data);
          if(isFeatureEnabled(response.data.availableFeatures,"ftr-new-automations-v1")
            ){
              fetchAutomationAuthToken(response.data.emailId, response.data.userId);
          }

        }catch(e){
          console.log("error while settings availableFeatures ",e);
        }
        dispatch({
          type: SAVE_USER_DETAILS,
          payload: response.data
        });

        if(typeof callback === 'function'){
          callback(true);
        }
      },
      onfail: () => {
        if(typeof callback === 'function'){
          callback(false);
        }
        dispatch({ type: USER_DETAILS_FETCH_FAILED });
      }
  })
  };
}
